import { Container, Grid } from '../../../Layout';
import { Box } from '../../../Miscellaneous/Box';
import { MobileBottomButton } from '../../Buttons/MobileBottomButton';

const MOBILE_BOTTOM_BUTTON_HEIGHT = 80;

type OneToTwoLayoutTemplate = {
  showLeftSection?: boolean;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  mobileBottomButton?: React.ReactNode;
};

const OneToTwoLayoutTemplate = ({
  showLeftSection = true,
  leftSection,
  rightSection,
  mobileBottomButton,
}: OneToTwoLayoutTemplate) => {
  return (
    <Container
      size="xl"
      px={{ base: 'sm', xl: 0 }}
      mb={mobileBottomButton ? MOBILE_BOTTOM_BUTTON_HEIGHT : undefined}
    >
      <Grid gutter={{ base: 'lg', sm: 'xl' }}>
        {showLeftSection && (
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Box>{leftSection}</Box>
          </Grid.Col>
        )}
        <Grid.Col span={{ base: 12, md: 8 }} offset={{ base: 0, md: !showLeftSection ? 2 : 0 }}>
          <Box>{rightSection}</Box>
        </Grid.Col>
      </Grid>

      {mobileBottomButton && <MobileBottomButton>{mobileBottomButton}</MobileBottomButton>}
    </Container>
  );
};

export { OneToTwoLayoutTemplate };
